export function getServiceReportPaymentAmounts(service) {
  const base = Number(service?.price ?? 0);
  const vat = Number(service?.vat_amount ?? Math.ceil(
    base * Number(service?.vat_percentage ?? 0) / 100
  ));
  const total = Number(service?.total_payment_amount ?? (base + vat));
  const paid = Number(service?.paid_amount ?? Math.max(
    total - Number(service?.payment_amount ?? total), 0
  ));
  const remaining = Number(service?.payment_amount ?? Math.max(total - paid, 0));
  const multiPayment = service?.multi_payment ?? (service?.status === "second_waiting");
  // Match checkout: split the discounted base and VAT separately before adding.
  const first = Math.floor((total - vat) / 2) + Math.floor(vat / 2);
  const type = multiPayment ? (paid < first ? "first" : "second") : "total";
  const amount = multiPayment && paid < first ? Math.min(first - paid, remaining) : remaining;

  return {
    vat,
    total,
    paid,
    // Older report responses expose payment_amount without the link fields.
    // An explicit zero from the server still means there is nothing to pay.
    amount: Number(service?.payment_link_amount ?? amount),
    type: service?.payment_link_type ?? type,
  };
}
